"use strict";

angular.module('PatientApp').factory('UsageDataService', function (VuexStore) {
  return {
    record: function record(providerId, statType, statGroup, statValue) {
      return VuexStore.dispatch('recordUsage', {
        'providerId': providerId,
        'statType': statType,
        'statGroup': statGroup,
        'statValue': statValue
      });
    },
    log: function log(type, event, secureCode) {
      return VuexStore.dispatch('logUsage', {
        'type': type,
        'event': event,
        'secureCode': secureCode
      });
    }
  };
});